import cn from 'classnames'
import { Button } from 'components/ui'
import { useCart } from 'hooks/use-cart'
import {useMercadinho, useUserSession} from 'hooks'
import { useState } from 'react'
import type { FC } from 'react'
import { ROUTE_USER_ACCOUNT } from 'routes/user'
import s from './cart-checkout-button.module.css'
import type { CartCheckoutButtonProps } from './types'

const CartCheckoutButton: FC<CartCheckoutButtonProps> = ({
  onClick,
  fromWidget = false,
  className,
  label = 'Ir para o carrinho',
  ...rest
}) => {
  const { block } = useCart()
  const { user, isLoggedIn } = useUserSession()
  const { isMercadinho } = useMercadinho()

  const [error, setError] = useState<boolean>(false)

  const interceptClick = (e: any) => {
    if (isLoggedIn) {
      const userName = user.name

      if (!userName.includes(' ')) {
        setError(true)
        return
      }
    }

    if (onClick) {
      onClick(e)
    }
  }

  const ErrorComponent = () => {
    return (
      <>
        <p className={s.error}>
          O nome no seu cadastro está incompleto,{' '}
          <a href={ROUTE_USER_ACCOUNT}>
            <strong>clique aqui</strong>
          </a>{' '}
          e atualize seus dados para continuar com sua compra.
        </p>
      </>
    )
  }

  if (isMercadinho || fromWidget) {
    return (
      <>
        {error && <ErrorComponent />}
        <Button onClick={interceptClick} className={cn(s.root, className)} {...rest}>
          {label}
        </Button>
      </>
    )
  }

  return (
    <>
      {error && <ErrorComponent />}
      {block ? (
        <div className={s.error}>
          {block}
          <br />
          <small>Remova do carrinho os produtos que não podem ser entregues para continuar com a compra.</small>
        </div>
      ) : (
        <Button onClick={interceptClick} className={cn(s.root, className)} {...rest}>
          {block
            ? 'Há produtos que não podem ser entregues no seu endereço. Retire-os do carrinho ou altere o CEP para continuar.'
            : label}
        </Button>
      )}
    </>
  )
}

export default CartCheckoutButton
